import { AUTH_MODE, keycloakAuthService } from '@/auth/keycloak'
import { store } from '@/app-storage/store'
import axios, { AxiosError } from 'axios'

export class AuthService {
  static async getAccessToken(): Promise<string | null> {
    if (AUTH_MODE === 'keycloak') {
      await keycloakAuthService().ensureFreshToken(30) // ensure token is fresh
      const token = keycloakAuthService().getAccessToken()
      return token ?? null
    } else {
      const AuthSession = store.getState().AuthSession
      return AuthSession?.auth_badge?.access_token ?? null
    }
  }

  static async handleAuthError(error: AxiosError) {
    const status = error.response?.status
    if (
      AUTH_MODE === 'keycloak' &&
      (status === 401 || status === 403) &&
      keycloakAuthService().isAuthenticated()
    ) {
      try {
        await keycloakAuthService().ensureFreshToken(0)

        const cfg = error.config
        if (cfg) {
          cfg.headers = cfg.headers || {}
          const token = keycloakAuthService().getAccessToken()
          if (token) cfg.headers.Authorization = `Bearer ${token}`
          return axios(cfg)
        }
      } catch {
        keycloakAuthService().login()
        return
      }
    }
    throw error
  }
}
